import {Component, h, Prop, State} from '@stencil/core';
import {getDataFromPropString} from '../../utils/utils';
import {htmlSanitizer} from "@utils/html-sanitizer";
import { ga4TrackingOfferEvent } from "@utils/offer-utils";

@Component({
  tag: 'vs-offer-bundle',
  styleUrl: './_vs-offer-bundle.scss',
})
export class OfferBundle {
  @Prop() offerBundleData: string | JSON;
  @Prop() layout: string = 'content-library';
  @Prop() headerId: string = 'contentLibraryBundleHeader';
  @State() allProps = {};
  imgAltTextCleaned = '';
  imgPath: string = '';
  ctaItem: any;
  cardBadges: [];

  componentWillLoad() {
    this.allProps = typeof (this.offerBundleData) === 'string' ? getDataFromPropString(this.offerBundleData) : this.offerBundleData;
    this.setupCTA(this.allProps);
  }

  componentWillUpdate() {
    this.allProps = typeof (this.offerBundleData) === 'string' ? getDataFromPropString(this.offerBundleData) : this.offerBundleData;
    this.setupCTA(this.allProps);
  }

  setupCTA = (allProps: {}) => {
    this.imgPath = this.allProps['desktopImagePath'];
    this.imgAltTextCleaned = this.allProps['desktopAltText'].toLowerCase() === 'na' ? '' : this.allProps['desktopAltText'];
    this.ctaItem = allProps['ctas'][0];
    this.cardBadges = allProps['cardBadges'];
  };

  clickOfferBundle = () => {
    // trigger GA event
    ga4TrackingOfferEvent(this.ctaItem.perkGa4Event);
    window.location.assign(this.ctaItem.ctaLink);
  }

  // START GENAI@GHCOPILOT
  renderBadges() {
    if (this.cardBadges.length > 1) {
      return (
        <ul>
          {this.cardBadges.map((badgeLabel) => (
            <li
              class="contrast-borders"
              style={{
                'background-color': badgeLabel["backgroundColor"],
                color: badgeLabel["textColor"],
                'border-radius': '1px',
                display: 'inline-block',
                'font-size': '13px',
                margin: '0px 5px 5px 0px',
                padding: '2px 5px',
              }}
            >
              {badgeLabel["value"]}
            </li>
          ))}
        </ul>
      );
    } else {
      return this.cardBadges.map((badgeLabel) => (
          <p
            class="contrast-borders"
            style={{
              'background-color': badgeLabel["backgroundColor"],
              color: badgeLabel["textColor"],
              'border-radius': '1px',
              display: 'inline-block',
              'font-size': '13px',
              margin: '0px 5px 5px 0px',
              padding: '2px 5px',
            }}
          >
            {badgeLabel["value"]}
          </p>
        ));
    }
  }
  // END GENAI@GHCOPILOT

  render() {
    return (
      <div class="vs-offer-bundle" data-layout={this.layout}>
        <div class="vs-offer-bundle-media" onClick={this.clickOfferBundle}>
          <img class="vs-offer-bundle-img vs-img-lazy" src={this.imgPath} alt={this.imgAltTextCleaned}/>
          <h3 class="vs-h3 vs-offer-bundle-header"
              innerHTML={htmlSanitizer(this.allProps['headerText'])} {...(this.headerId.length > 0 ? {id: this.headerId} : {})}/>
          <div class="vs-pt-1 vs-align-left">
            {this.renderBadges()}
          </div>
        </div>

        <div class="vs-offer-bundle-cta">
          <div class="vs-bundle-cta-item" key={this.ctaItem.uniqueId}>
            <vs-link
              link-aria-label={this.ctaItem.ctaLinkAriaLabel}
              button-color={this.ctaItem.ctaButtonColor}
              link-conversion={this.ctaItem.ctaConversionType}
              link-type={this.ctaItem.ctaLinkType}
              link-style={this.ctaItem.ctaStyle}
              has-dark-bg="no"
              link-target={this.ctaItem.ctaLinkTarget}
              link-text={this.ctaItem.ctaTitle}
              link-val={this.ctaItem.ctaLink}
              modal-target={this.ctaItem.ctaUniqueId}
              is-no-follow={this.ctaItem?.ctaNoFollow}/>
          </div>
        </div>
      </div>
    );
  }
}
